'use client'

import { TransparencyLaw } from '@marketplace-web/domain/legal-block'
import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'

import { ItemPageTransparencyLawPluginModel } from './types'

type Props = {
  data?: ItemPageTransparencyLawPluginModel
}

const ItemPageTransparencyLawPlugin = ({ data }: Props) => {
  const rightOfWithdrawalInItemPageAbTest = useAbTest('right_of_withdrawal_in_item_page')

  useTrackAbTest(rightOfWithdrawalInItemPageAbTest, data && !data.isBusiness)

  if (!data) return null
  if (data.isBusiness) return null

  return (
    <TransparencyLaw
      subject={
        rightOfWithdrawalInItemPageAbTest?.variant === 'on'
          ? TransparencyLaw.TransparencyLawSubject.RightOfWithdrawal
          : TransparencyLaw.TransparencyLawSubject.BuyerRights
      }
    />
  )
}

export default ItemPageTransparencyLawPlugin
